import { render, staticRenderFns } from "./EditNameAlbumsChat.vue?vue&type=template&id=42b9f947&scoped=true&lang=html&"
import script from "./EditNameAlbumsChat.vue?vue&type=script&lang=js&"
export * from "./EditNameAlbumsChat.vue?vue&type=script&lang=js&"
import style0 from "./EditNameAlbumsChat.vue?vue&type=style&index=0&id=42b9f947&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b9f947",
  null
  
)

export default component.exports